@ -0,0 +1,703 @@
<template>
  <div id="mask"  v-show="pubiliczeShow">
    <!-- 宣传活动 -->
    <div class="pubilicze-coont">

 
   <div class="game-feature">
    <img
          src="../../../assets/image/mb/order/upload/error.png"
          alt=""
          class="title"
          @click="closePubilicze"
          
        />
        <div class="panel">
         <div class="panel-content">
           <div class="panel-content-image">宣传活动</div>
           <!-- <div class="panel-false-content" v-show="propagateDivState==0" ><span style="color:#c1683b ;">活动已结束</span></div> -->
        <!-- 存储图片的数组 -->
           <ul  v-show="propagateUlState==0">
            <li v-for="(image, index) in images" :key="index">
              <div class="closeImage" @click="handleUploadUlClick(index)" v-show="propagateStateImage==1" ></div>
              <img :src="image" @click="reviewImage(image)"/>
            </li>
           </ul>
         <!-- 展示图片点击放大-->

         <ul  v-show="propagateUlState>=1">
          <li v-for="item in uploadImagesList" :key="item">
            <img @click="reviewImage(item)" :src="item"/>
          </li> 
          
        </ul>
         <!-- 展示图片点击放大end-->
           <input type="file" @change="uploadImage" multiple="multiple" accept="image/*" style="display: none" ref="fileInput">
           <!-- <div class="panel-button" @click="addItem" v-show="propagateState==0" >上传图片</div> -->
           <!-- <input type="file" @change="onFilesChange" multiple> -->
           <!-- <button @click="uploadImagesFile">上传</button> -->
          <input type="file" @change="uploadImage" multiple="multiple" accept="image/*" style="display: none" ref="fileInput">
           <div class="panel-button" @click="addItem" v-show="propagateState==0" >参与活动</div>
           <div class="panel-button-smbit" @click="handleUpload()"  v-show="propagateUlStateSbmit==1" >提交</div>
           <div class="panel-button-block"  @click="handlePropagateDialog(5)" v-show="propagateButtonType==1">审核通过</div>
           <div class="panel-button-not" v-show="propagateButtonAwaitType==1">审核中</div>
           <div class="panel-button-pass" v-show="propagateButtonNotType==1"  @click="handleNotUpload()" >未通过(重新上传)</div>
           <div class="panel-details"  @click="handlePropagateDialog(4)">
            详情
          </div>
         </div>
     

        </div>
     
   
      </div>
  
  </div>
    <!-- 登录 -->
    <template>
      <LoginDialog
        v-if="loginShowOne"
        :show="loginShowOne"
        class="myLoginDialog"
        @close="loginDialogClose(false)"
      ></LoginDialog>
    </template>
        <!-- 弹窗 -->
        <van-dialog
          v-model="dialogShow"
          title=""
          theme="round-button"
          message-align="center"
          :show-confirm-button="false"
          :close-on-click-overlay="true"
        >
          <div class="dialog-content">
            <!-- 宣传详情 -->
             <template v-if="dialogType == 4">
               <div  style=" width: 100%; text-align:left;">  
                <br/>
                将下图转发到任意游戏百人群内，<b>等待两分钟后将信息进行截图保存</b>，通过<b>官网首页</b>进行上传（一张图即可）。审核通过即可获得宣传礼包码。<br/>
                <br/>
                <img style="width: 80%; height: 130px;margin-left: 10%;" @click="reviewImage(getCopywritingContent.icon)"  :src="getCopywritingContent.icon" />
                <br/>
                <br/>

                <p>活动有效日期：9月15日12:00至10月15日12:00</p>
                <p>宣传礼包码内容：绑定生汤药*2000、绑定福寺草*500</p>
                <p><b>注：宣传礼包码一个账号只能使用一次，仅可以在正式帝王区使用</b></p>
    
                <br>
              </div>
              <br>
             
           
<!--             
                  <div @click="copy(getCopywritingContent.content)" style="width: 20%; margin: auto;">复制内容</div> -->
                </template>

               <!-- 宣传详情 -->
               <template v-if="dialogType == 5">

               <div style="width: 100%;height: 10px; margin-top:8% ;text-align:center"> 宣传码：{{propagateCode}}</div>
              <br/>
               <div style="width: 100%;height: 30px; text-align:center" @click="copy(propagateCode)" >复制宣传码</div>

             </template>
                <!-- 审核中耐心等待 -->
                <template v-if="dialogType == 6">

                <div  style="margin: auto; margin-top: 8%;margin-left: 23%;">  审核中耐心等待</div>

                </template>

                   <!-- 确认按钮 -->
                   <template v-if="dialogType == 7" v-show="true">
 
             
                      <div class="dialog-title-pass" style="margin: auto; margin-top: 8%;margin-left: 23%;"> 
                        <el-button type="danger"  v-show="propagateState==0"  @click="sbmitClose" plain>取消</el-button>
                        <el-button type="primary"  v-show="propagateState==0"  @click="handleUpload()"  plain>提交</el-button>

                      </div>

                    </template>

                        <!-- 确认按钮 -->
                   <template v-if="dialogType == 8" v-show="true">
                   
                    <div class="dialog-title-pass" style="width: 300px;height:140px;"> 
                      <div style="width: 98%; height: 120px; margin: auto; text-align: center;" >  
                        {{blockMark}}
                        </div>
                    
                    </div>
                    <div class="dialog-title-button" style="margin: auto; margin-top: 2%;margin-left: 23%;">
                      <el-button type="danger"    @click="close" plain>取消</el-button>
                      <el-button type="primary"   @click="handlePassUpload()"  plain>重新上传</el-button>
                    </div>
                    </template>
                    <!-- 最少四张照片 -->
                    <template v-if="dialogType == 9" v-show="true">
                   
                   <div class="dialog-title-pass" style=" width: 300px;height:50px;"> 
                     <div style="width:99%; height: 60px; margin: auto; text-align: center;" >  
                        请上传1张符合宣传的图片，上传图片的数量不能小于1张，请检查上传图片的数量
                      </div>
                   
                   </div>
                   <br/>
                   <div class="dialog-title-button" style="margin: auto; margin-top: 2%;">
                     <el-button type="danger"    @click="close" plain>取消</el-button>
                   </div>
                   </template>
                   
                   <template v-if="dialogType == 10" v-show="true">
                   
                   <div class="dialog-title-pass" style=" width: 300px;height:50px;"> 
                     <div style="width:99%; height: 60px; line-height: 80px; margin: auto; text-align: center;" >  
                       宣传活动已结束！
                      </div>
                   
                   </div>
                   <br/>
                   <div class="dialog-title-button" style="margin-left:38%; margin-top: 2%;">
                     <el-button type="danger"    @click="close" plain>取消</el-button>
                   </div>
                   </template>
                   <template v-if="dialogType ==11" v-show="true">
                   
                   <div class="dialog-title-pass" style=" width: 300px;height:50px;"> 
                     <div style="width:99%; height: 60px; line-height: 80px; margin: auto; text-align: center;" >  
                       只需上传一张图片即可！
                      </div>
                   
                   </div>
                   <br/>
                   <div class="dialog-title-button" style="margin-left:38%; margin-top: 2%;">
                     <el-button type="danger"    @click="close" plain>取消</el-button>
                   </div>
                   </template>
          </div>
        </van-dialog>
</div>
</template>

<script>

import { getToken } from "@/utils/auth";
import { Notify, Dialog } from "vant";
import LoginDialog from "../../../components/public/LoginDialog";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { ImagePreview } from 'vant';
import webSite from "../../../api/webSite";
import axios from 'axios';

export default {
  show: {
      type: Boolean,
      default: () => {
        return true;
      },
    },
  
  data() {




    return {
      pubiliczeShow:false,
      dialogShow: false,
      dialogType: "",
      ruleForm: {
        imagesUrl: [],
      },
      propagateState:0,//默认宣传状态 0 未参与 1参与
      propagateImageLength:0,//默认数组长度
      propagateDivState:0,//控制div礼包码显示
      propagateUlState:0,//控制图片UI
      propagateStateImage:0,
      propagateUlStateSbmit:0,//控制提交按钮
      propagateButtonType:0,//改变提交状态
      propagateButtonAwaitType:0,//审核等待中
      propagateButtonNotType:0,//审核拒绝
      propagateCode:"",//宣传码
      propagateText:"",//宣传码
      blockMark:"", //审核拒绝原因
      closePropagateTimeout: null,
      uploadImages:[],//存储上传的图片数组
      uploadImagesList:[],//获取宣传活动图片
      getCopywritingContent:{},
      files:[],//存储多图上传
      filesNumber:4,//默认数组上传多少张照片 
           imageSrc: 'https://qxz-image-1323839501.cos.ap-beijing.myqcloud.com/upload/2024-07-23/1721730502169.png?q-sign-algorithm=sha1&q-ak=AKIDNuZJHHHHKzyz08NoPE4qghgZbeeYG7xj&q-sign-time=1721730492%3B1753266492&q-key-time=1721730492%3B1753266492&q-header-list=host&q-url-param-list=&q-signature=33fe94676276332f274b1f103bb78c5289eb0b11',
      start: { x: 0, y: 0 },
      scale: 1,
      images: [],
      };
    },
    
    components: { LoginDialog },
  computed: {
    ...mapGetters({

      loginShowOne: "base/loginShowOne",
    }),
  },

  mounted() {
    this.getUploadImages();//获取宣传图片
    this.getCopywriting(); //获取宣传内容
  
  },
 
  methods: {
    ...mapMutations({
      loginDialog: "base/loginDialog",
    }),
    
    loginDialogClose(state) {
      this.loginDialog(state);
    },
    closePubilicze() {
      this.pubiliczeShow=false;
    },
    sbmitClose(){
      this.dialogShow = false
    // 关闭上传按钮
      this.propagateUlStateSbmit=1
      this.propagateState=1
      this.propagateStateImage=1
    },
      //多图上传
      async  addItem() {
        this.files = []; 
        this.uploadImages = [];
      if (getToken()!=undefined) {
        // this.dialogType = 10;
        // this.dialogShow = true;
      this.$refs.fileInput.click(); // 触发文件选择
      
    }else{
      this.loginDialog(true);
      this.pubiliczeShow=false;

      }
    },
    // 未审核通过重新上传
    addNotItem() {
      // this.dialogType = 10;
      // this.dialogShow = true;
      this.$refs.fileInput.click(); // 触发文件选择
    },
    //审核被拒绝增加未通过原因
    handleNotUpload(){
      this.dialogType = 8;
      this.dialogShow = true;
      // this.dialogType = 10;
      // this.dialogShow = true;
    },
    //删除图片数组指定的图片
    handleUploadUlClick(index){
      this.filesNumber=this.filesNumber-1// 赋值图片数量
        this.propagateUlStateSbmit=0 // 关闭上传按钮
        this.propagateState=0
        this.propagateStateImage=1
       
      this.uploadImages.splice(index, 1);
      this.images.splice(index, 1);
      if( this.uploadImages.length==0){
        this.propagateDivState=1//改变div状态
      }
     
      // console.log('Clicked item with index:', index);
      // console.log('Clicked item with uploadImages:', this.uploadImages);
    },
    //关闭弹框
    closeproPagateModal() {
      this.propagateState=1;//改变提交状态
      this.propagateType==2 //审核中
      // console.log("propagateState"+ this.propagateState);
      this.dialogShow = false;
      clearTimeout(this.closePropagateTimeout);
   
    },
    //上传图片长度限制
    async addUploadImages(){
      if(this.uploadImages.length==1){
        this.dialogType = 7;
       this.dialogShow = true;
         
            }
              
     },
     onFilesChange(e) {
      this.files = e.target.files;
    },
   uploadImage(event) {
    // this.dialogType = 10;
    // this.dialogShow = true;
        
        this.addUploadImages();
        this.files= event.target.files;
        //判断数组的图片+上传图片是否大于4，大于停止上传
        let imageCount=this.files.length+this.uploadImages.length
           //控制图片长度
        if(imageCount>1){
          this.dialogType =11;
          this.dialogShow = true;
          return;
        }
        const formData = new FormData();
        // formData.append('file', file);
        for (let i = 0; i < this.files.length; i++) {
          formData.append('files', this.files[i]);
        }


        if(this.propagateButtonNotType==1){
          this.propagateState=0//设置参与状态
          this.propagateButtonNotType=0 //设置关闭状态
          this.propagateUlState=0 //关闭后台图片显示

        }
        axios.post('https://www.q1000y.cn/backend/api/oss/v2/upload',formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })

        .then( response => {
              this.uploadImages.push(...response.data.data);
            //关闭显示礼包div
                if(this.uploadImages.length>0){
                  this.propagateDivState=1;
                  this.propagateStateImage=1
                }
                //控制图片长度
                if(this.uploadImages.length<=1){
                //给指定的li 赋值
                this.images.push(...response.data.data);
                this.addUploadImages();
              
                }
                
          })


        },

    //审核被拒绝重新上传
    handlePassUpload(){
        this.dialogShow = false; //关闭弹框
        this.propagateButtonNotType=0 //关闭审核按钮
        this.propagateState=0//显示图片上传按钮
        this.propagateUlState=0 //关闭数据显示的图片UI

      },

//通过提交事件上传图片
async handleUpload(){
  // this.dialogType = 10;
  // this.dialogShow = true;
   //调用图片提交审核看着上传图片长度
   if(this.uploadImages.length==1){
   let params = { imageUrls: this.uploadImages,phoneNumber: this.$store.state.user.userPropagateInfo};

              let res = await webSite.addUploadFile(params);
              if (res.code == 200) {
                this.propagateState=1
                this.propagateStateImage=1
             
         
                this.dialogType = 6; 
                this.dialogShow = true;
            
            
                this.closeTimeout = setTimeout(() => {
                  this.propagateState=1
                  this.propagateUlStateSbmit=0 // 关闭上传按钮
                  this.propagateButtonAwaitType=1 
                  if( this.propagateButtonAwaitType==1){
                  this.propagateStateImage=0
                }
                  this.closeproPagateModal();
                }, 3000); // 弹框将在3秒后自动关闭
                
            }else{
              // console.log( res.code);
            }
          }
    },

    //根据手机号获取图片
    async getUploadImages() {
      // console.log("手机号"+ this.$store.state.user.userPropagateInfo);
      let params = {phoneNumber: this.$store.state.user.userPropagateInfo};
      let res = await webSite.getUploadImages(params); 
      if(res.code==200){  
        // alert("获取"+this.$store.state.user.userPropagateInfo)
        if(res.data.length>0){
          this.propagateDivState=1,//改变div状态
          this.propagateUlState=1,//数组图片UI状态
          this.propagateState=1//设置参与状态
          if(res.data[0].state=="PASS"){
            this.propagateButtonType=1
          }else if(res.data[0].state=="REVIEW"){
            this.propagateButtonAwaitType=1
          }else if(res.data[0].state=="BLOCK"){
            this.propagateButtonNotType=1
          }
          this.propagateStateImage=0
          this.propagateUlStateSbmit=0 // 关闭上传按钮
          this.propagateCode= res.data[0].giftCode //获取宣传码
          this.uploadImagesList= res.data[0].imageUrls;
          this.blockMark=res.data[0].blockMark; //获取驳回原因
          console.log( this.propagateButtonType);
        }
        
        
      }
    },
    //获取宣传内容
    async getCopywriting() {
      let res = await webSite.getCopywriting(); 
      if(res.code==200){ 
        this.getCopywritingContent=res.data
        console.log( res.data)
      }

    },
 //宣传详情
  handlePropagateDialog(type){
        this.dialogType = type;
        if(type == 4){
          this.dialogShow = true;
        }else if(type == 5){
          this.dialogShow = true;
        }
      
      },

    //点击放大图片
    reviewImage(url){
      ImagePreview([url])
    },

        // 一键复制
    async copy(content) {
      try {
        let res = await this.$utils.doCopy(content);
        Notify({ type: "success", message: res });
        setTimeout(() => {
          this.dialogShow = false;
        }, 1000);
      } catch (error) {
        Notify({ type: "error", message: error });
      }
    },

    //关闭
    close() {
  this.dialogShow = false
    },

  }
}
</script>

<style lang="scss" scoped>


//宣传活动
#mask {
    position: fixed;
    top: 0;
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    background-color: rgba($color: #000000, $alpha: 0.5);
    z-index: 1;
  }
.pubilicze-coont{
   position: fixed;
    top: 0;
    width: 100%;
    display: flex;
    justify-content: center;
    background-color: rgba($color: #000000, $alpha: 0.5);
  }
.game-feature {
      position: fixed;
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 375px;
      height: auto;
      z-index: 1;
      margin-top:50%;
      .title {
        position: relative;
        width: 25px;
        height: 25px;
        margin-left:92%;
        z-index:1
      }
      .panel {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 245px;
        background-image: url('../../../assets/image/mb/order/upload/bj.png'); /* 背景图片路径 */
        // background: url("../../../assets/image/mb/order/basemap-feature.png");
        background-size: 100% 100%;
        .panel-content{
          width: 100%;
          height: 245px;  
          .panel-content-image{
          width: 100%;
          height: 58px;
          font-size: 20px;
          line-height: 96px;
          letter-spacing: 2px;
          color: #7f6240;
          font-weight:bolder;
          text-align: center;
        }
        .panel-false-content{
          width: 100%;
          height: 1px;
          font-size: 16px;
          line-height: 110px;
          letter-spacing: 3px;
          color: #7f6240;
          text-align: center;
        }
        .panel-button{
          width: 140px;
          height: 40px;
          border: 0px solid;
          margin: auto;
          text-align: center;
          line-height: 40px;
          font-weight: bolder;
          font-size: 14px;
          color: #7f6240;
          background-image: url('../../../assets/image/mb/order/upload/true.png'); /* 背景图片路径 */
          background-size: 100% 100%;
        }
        .panel-button-not{
          width: 145px;
          height: 40px;
          border: 0px solid;
          margin: auto;
          background-image: url('../../../assets/image/mb/order/upload/not.png'); /* 背景图片路径 */
          background-size: 100% 100%;
          text-align: center;
          line-height: 40px;
          font-weight: bolder;
          font-size: 14px;
        }
        .panel-button-block{
          width: 140px;
          height: 40px;
          border: 0px solid;
          margin: auto;
          background-image: url('../../../assets/image/mb/order/upload/block.png'); /* 背景图片路径 */
          background-size: 100% 100%;
          text-align: center;
          line-height: 40px;
          font-weight: bolder;
          font-size: 14px;
          color: #fff;
        }
        .panel-button-pass{
          width: 140px;
          height: 40px;
          border: 0px solid;
          margin: auto;
          background-image: url('../../../assets/image/mb/order/upload/pass.png'); /* 背景图片路径 */
          background-size: 100% 100%;
          text-align: center;
          line-height: 40px;
          font-weight: bolder;
          font-size: 14px;
          color: #fff;
        }
        .panel-button-smbit{
          width: 140px;
          height: 40px;
          border: 0px solid;
          margin: auto;
          background-image: url('../../../assets/image/mb/order/upload/true.png'); /* 背景图片路径 */
          background-size: 100% 100%;
          text-align: center;
          line-height: 40px;
          font-weight: bolder;
          color: #409eff;
          font-size: 14px;
        }
        .panel-details{
          width: 100px;
          height: 30px;
          font-size: 16px;
          line-height: 20px;
          color: #7f6240;
          text-indent: 2em;
          float: right;
          background-image: url('../../../assets/image/mb/order/upload/detail.png')  ; /* 背景图片路径 */
          background-repeat: no-repeat;
          background-size: 20px 20px ;
          // img{
          //   position: relative;
          //   width: 20px;
          //   height: 20px;
            
          // }
        }
        ul{
          width: 80%;
          height:70px;  
          padding: 10px;
          margin: auto;
          li{
            width: 20%;
            height: 100%;
            list-style: none;
            padding: 0;
            background-image: none;
            float: left;
            margin-left: 4%;
            .closeImage{
            position: absolute;
            z-index: 1;
            width: 20px;
            height: 20px;
            background-image: url('../../../assets/image/mb/order/upload/error.png')  ; /* 背景图片路径 */
            background-repeat: no-repeat;
            background-size: 20px 20px ;
          }
          }
          img{
            width: 58px;
            height: 60px;
          }
        
        }
          
        }
       
      }

      .dialog-content{
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 20px 0;
        background: url("../../../assets/image/mb/order/basemap-dialog.png");
        background-size: 100% 100%;
      
        .record-content {
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 95%;
          color: #c1683b;

          .record-item {
            display: flex;
            justify-content: space-between;
            width: 100%;
            height: 20px;
            margin: 8px 0;
            border-bottom: 1px solid #c1683b;
            a {
              flex: 1;
              text-align: center;
              color: #c1683b;
              font-size: 12px;
            }
          }
          .warn {
            margin-top: 10px;
            color: #c1683b;
            font-size: 12px;
          }
        }
      
      }

    }

</style>